import axios from 'axios';

// set new axios instance
export default axios.create();
